import { AxiosResponse } from 'axios';
import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import { createRepository } from '@/repositories/GenericRepository';
import { AddressType, ValidatedAddress } from '@/types/address';
import { Jurisdiction } from '@/types/jurisdiction';
import PaginatedResponse from '@/types/paginatedResponse';
import { Address } from '@/types/person';
import ajax from '@/utils/ajax';

const basePath = '/api/dugout/person_address';
export const addressRepository = {
  ...createRepository<Address, Address>(basePath),

  async getTypes({ host }: { host: string }): Promise<PaginatedResponse<AddressType[]>> {
    const response = await ajax.get({ url: `${host}${basePath}/list_types/` });

    return response.data;
  },

  async validate({
    host,
    address
  }: {
    host: string;
    address: Address;
  }): Promise<ValidatedAddress[]> {
    const response = await ajax.post<Address, AxiosResponse<ValidatedAddress[]>>({
      url: `${host}${basePath}/validate/`,
      data: address
    });

    return response.data;
  },

  async getUsStatesList({ host }: { host: string }): Promise<Jurisdiction[]> {
    const response = await ajax.get({
      url: `${host}${basePath}/us_states_list/`
    });

    return response.data;
  }
};

const AddressRepository = () => {
  const { host } = useContext(AppContext);
  const { create, update, delete: _delete } = addressRepository;

  return {
    async create({ data }: { data: Partial<Address> }) {
      return create({ host, data });
    },

    async update({ id, data }: { id: string; data: Partial<Address> }) {
      return update({ host, id: id, data });
    },

    async delete({ id }: { id: string }) {
      return _delete({ host, id });
    },

    async getTypes(): Promise<PaginatedResponse<AddressType[]>> {
      return addressRepository.getTypes({ host });
    },

    async validate(address: Address): Promise<ValidatedAddress[]> {
      return addressRepository.validate({ host, address });
    },

    async getUsStatesList() {
      return addressRepository.getUsStatesList({ host });
    }
  };
};

export default AddressRepository;
